import React from "react";
import { StickyCta } from "./StepIntro";
import { Input } from "../ui/input";

/**
 * Collect cat basics — the fields the AI prompts need:
 * name, breed (optional), age (years), weight (kg).
 */
export function StepCatBasics({ value, onChange, onNext }) {
    const v = value;
    const nameOk = v.name.trim().length >= 1;
    const ageOk = Number(v.age) > 0 && Number(v.age) <= 40;
    const weightOk = Number(v.weight_kg) > 0 && Number(v.weight_kg) <= 25;
    const canContinue = nameOk && ageOk && weightOk;

    return (
        <div className="pb-24" data-testid="step-cat-basics">
            <div className="mt-2 space-y-3">
                <span className="eyebrow">Cat basics</span>
                <h1 className="font-display text-[2rem] font-medium leading-tight text-meow-charcoal">
                    Tell us about your cat.
                </h1>
                <p className="text-[15px] leading-relaxed text-meow-muted">
                    We only ask for what the assessment needs.
                </p>
            </div>

            <div className="mt-6 space-y-4">
                <Field label="Name" htmlFor="basics-name">
                    <Input
                        id="basics-name"
                        value={v.name}
                        onChange={(e) => onChange({ ...v, name: e.target.value })}
                        placeholder="e.g. Miso"
                        maxLength={40}
                        className="h-14 rounded-xl border-transparent bg-white text-base focus-visible:border-meow-teal focus-visible:ring-2 focus-visible:ring-meow-teal/20"
                        data-testid="basics-name-input"
                    />
                </Field>

                <Field label="Breed (optional)" htmlFor="basics-breed">
                    <Input
                        id="basics-breed"
                        value={v.breed}
                        onChange={(e) => onChange({ ...v, breed: e.target.value })}
                        placeholder="e.g. British Shorthair · leave blank if mixed"
                        maxLength={60}
                        className="h-14 rounded-xl border-transparent bg-white text-base focus-visible:border-meow-teal focus-visible:ring-2 focus-visible:ring-meow-teal/20"
                        data-testid="basics-breed-input"
                    />
                </Field>

                <div className="grid grid-cols-2 gap-3">
                    <Field label="Age (years)" htmlFor="basics-age">
                        <Input
                            id="basics-age"
                            type="number"
                            inputMode="decimal"
                            step="0.5"
                            min="0"
                            max="40"
                            value={v.age}
                            onChange={(e) => onChange({ ...v, age: e.target.value })}
                            placeholder="e.g. 4"
                            className="h-14 rounded-xl border-transparent bg-white text-base focus-visible:border-meow-teal focus-visible:ring-2 focus-visible:ring-meow-teal/20"
                            data-testid="basics-age-input"
                        />
                    </Field>
                    <Field label="Weight (kg)" htmlFor="basics-weight">
                        <Input
                            id="basics-weight"
                            type="number"
                            inputMode="decimal"
                            step="0.1"
                            min="0"
                            max="25"
                            value={v.weight_kg}
                            onChange={(e) => onChange({ ...v, weight_kg: e.target.value })}
                            placeholder="e.g. 4.5"
                            className="h-14 rounded-xl border-transparent bg-white text-base focus-visible:border-meow-teal focus-visible:ring-2 focus-visible:ring-meow-teal/20"
                            data-testid="basics-weight-input"
                        />
                    </Field>
                </div>
            </div>

            <StickyCta>
                <button
                    type="button"
                    className="meow-btn-primary w-full"
                    disabled={!canContinue}
                    onClick={onNext}
                    data-testid="basics-continue-btn"
                >
                    Start Phase 1
                </button>
            </StickyCta>
        </div>
    );
}

function Field({ label, htmlFor, children }) {
    return (
        <div>
            <label
                htmlFor={htmlFor}
                className="mb-1.5 block text-[13px] font-medium text-meow-charcoal"
            >
                {label}
            </label>
            {children}
        </div>
    );
}
